import MonthlyCategoriesTable from './MonthlyCategoriesTable'
export default MonthlyCategoriesTable
